import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaUserPlus,
  FaSignOutAlt,
  FaSignInAlt,
} from "react-icons/fa";

import "../styling/Navbar.css";
import ShowTime from "./LiveDateTime";
import { useAuth } from "../context/AuthContext"; // ✅ NEW
import FlashMessage from "./FlashMessage";
const Navbar = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const { user, logout } = useAuth(); // ✅ reactive auth state

  const handleLogout = () => {
    logout(); // clears storage + updates state
    window.location.reload();
    setMenuOpen(false);
    navigate("/login", { replace: true });
  };

  return (
    <header className="navbar">
      <div className="nav-container">
        {/* LEFT */}
        <div className="nav-logo" onClick={() => navigate("/loanlist")}>
          💰 MyLoanApp
        </div>

        {/* CENTER (Desktop only) */}
        <div className="nav-time">
          <ShowTime />
        </div>

        {/* RIGHT */}
        <div className={`nav-links ${menuOpen ? "open" : ""}`}>
          {user ? (
            <>
              <span className="nav-user">👋 {user.name}</span>

              {user.role === "admin" && (
                <Link
                  to="/register"
                  className="nav-btn secondary"
                  onClick={() => setMenuOpen(false)}
                >
                  <FaUserPlus /> Register User
                </Link>
              )}

              <button className="nav-btn danger" onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </button>
            </>
          ) : (
            <></>
          )}
        </div>

        {/* MOBILE TOGGLE */}
        <button
          className="menu-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Navbar;
